module.exports = __webpack_public_path__ + "img/parter-avatar6.4e889ded.png";